<template>
  <section id="calendar-sheet__section--image">
    <teleport to="body">
      <div
        id="calendar-sheet__section--image-teleport"
        class="absolute top-0 left-0 w-full h-full z-10 pointer-events-none"
      >
        <!-- Download -->
        <a
          v-if="routedDay.calendarSheetDownload?.publicUrl"
          id="calendar-sheet__download"
          :href="routedDay.calendarSheetDownload.publicUrl"
          target="_blank"
          class="absolute bottom-0 right-0 mb-5 pointer-events-auto button bg-orange-500 hover:bg-orange-600 text-white z-10 scale-100 hover:scale-105 translate-x-1/2 mr-[25%]"
          >Download</a
        >

        <!-- Backdrop -->
        <div
          id="calendar-sheet__backdrop"
          @click="toggleActive"
          class="absolute inset-0 bg-black z-10 transition-all duration-300 will-change-[opacity]"
          :class="[
            state === 'active'
              ? [
                  'bg-opacity-50',
                  'pointer-events-auto',
                  'supports-bg-filter:bg-saturate-blur-full',
                ]
              : [
                  'bg-opacity-0',
                  'pointer-events-none',
                  'supports-bg-filter:bg-saturate-blur-0',
                ],
          ]"
        />

        <!-- Image (`absolute` merely for stacking context above backdrop) -->
        <a
          v-if="routedDay.calendarSheet?.publicUrl"
          id="calendar-sheet__image"
          :href="routedDay.calendarSheet.publicUrl"
          @click.prevent="toggleActive"
          class="group absolute inline-block z-20 transition-transform duration-300 pointer-events-auto will-change-transform"
          :class="[{ [state]: true }]"
        >
          <img
            :src="routedDay.calendarSheet.publicUrl"
            :alt="routedDay.title"
            class="h-[82vh] w-auto shadow-md group-hover:shadow-xl rounded-[30px] transition-shadow duration-300"
          />
        </a>
      </div>
    </teleport>
  </section>
</template>

<script>
import { Teleport } from "vue";

import { mapGetters } from "vuex";

export default {
  name: "CalendarSheetImage",
  components: {
    Teleport,
  },
  data() {
    return {
      state: "offscreen",
      offscreenToIdleTimeout: null,
    };
  },
  computed: {
    ...mapGetters(["routedDay"]),
  },
  mounted() {
    this.offscreenToIdleTimeout = window.setTimeout(() => {
      this.state = "idle";
    }, 100);
  },
  beforeUnmount() {
    window.clearTimeout(this.offscreenToIdleTimeout);
  },
  methods: {
    toggleActive() {
      this.state = this.state === "active" ? "idle" : "active";
    },
  },
};
</script>
